import script from "./GrProcessoPje.vue?vue&type=script&setup=true&lang=js"
export * from "./GrProcessoPje.vue?vue&type=script&setup=true&lang=js"

import "./GrProcessoPje.vue?vue&type=style&index=0&id=e398e1e2&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
